import React from "react";

import PropTypes from "prop-types";

import Logo from "./logo";
import CTA from "./c-t-a";
import PrimaryButton from "./primary-button";
import "./style2.css";

const Style2 = (props) => {
  return (
    <div data-role="Header" className={`style2-style1 ${props.rootClassName} `}>
      <header className="style2-header">
        <Logo className="" image_src={props.logo}></Logo>
        <CTA
          rootClassName="c-t-a-root-class-name1"
          className=""
          heading={props.title}
          subtitle={props.subtitle}
        ></CTA>
        <div className="style2-container">
          <div className="style2-store-banner">
            <PrimaryButton
              buttonText={props.buttonText}
              hostingUrl={props.hostingUrl}
              buttonColor={props.buttonColor}
              className=""
            ></PrimaryButton>
          </div>
        </div>
      </header>
    </div>
  );
};

Style2.defaultProps = {
  rootClassName: ""
};

Style2.propTypes = {
  rootClassName: PropTypes.string
};

export default Style2;
